module.exports = __webpack_public_path__ + "img/homekv7.556d79a9.jpg";